'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var sessionWarningDurationMs = 600000; // default is 10 minutes

var SessionTimeoutTracker = function () {
    function SessionTimeoutTracker(sessionTimeoutTrackerObject) {
        _classCallCheck(this, SessionTimeoutTracker);

        var redirectUrl = sessionTimeoutTrackerObject.redirectUrl,
            warningTimeoutMs = sessionTimeoutTrackerObject.warningTimeoutMs;


        this.redirectUrl = redirectUrl;

        if (warningTimeoutMs) {
            sessionWarningDurationMs = warningTimeoutMs;
        }

        // set timeout when tracker is created
        this.sessionTimerWarningId = setTimeout(this.onSessionWarningTimeout, sessionWarningDurationMs);

        // can be used to compare current time with timer start time
        this.sessionTimerStart = new Date();

        this.onSessionWarningTimeout = this.onSessionWarningTimeout.bind(this);
    }

    _createClass(SessionTimeoutTracker, [{
        key: 'refreshLogOutTimer',
        value: function refreshLogOutTimer(statusCode) {
            if (statusCode !== 401 && statusCode !== 403) {
                this.clearLogOutTimer();

                // resets the date
                this.sessionTimerStart = new Date();

                this.sessionTimerWarningId = setTimeout(this.onSessionWarningTimeout, sessionWarningDurationMs);
            }
        }
    }, {
        key: 'onSessionWarningTimeout',
        value: function onSessionWarningTimeout() {
            if (typeof window !== 'undefined' && window.browserHistory) {
                window.browserHistory.push(this.redirectUrl);
            } else {
                window.location.assign(this.redirectUrl);
            }
        }
    }, {
        key: 'clearLogOutTimer',
        value: function clearLogOutTimer() {
            clearTimeout(this.sessionTimerWarningId);
        }
    }]);

    return SessionTimeoutTracker;
}();

exports.default = SessionTimeoutTracker;